import axios from "axios";

export const state = {
    dashboard: {},
    graphsData: {},
    loaded_status: false,
    filter_status: false,
};

export const getters = {
    dashboardData: state => state.dashboard,
    graphData: state => state.graphsData,
    loadedStatus: state => state.loaded_status,
    filterStatus: state => state.filter_status,
};
export const mutations = {
    SET_DASHBOARD_DATA(state, newValue) {
        state.dashboard = newValue
    },
    SET_GRAPH(state, newValue) {
        state.graphsData = newValue
    },
    SET_LOADED(state) {
        state.loaded_status = true
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    }
};

export const actions = {
    fetchDashboard({ commit, dispatch }) {
        axios.get('dashboard').then(res => {
            commit('SET_DASHBOARD_DATA', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchGraph({ commit, dispatch }) {
        axios.get('exp_salesgraph').then(gres => {
            commit('SET_GRAPH', gres.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    filterDashboard({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true)
        axios.post('filter_dashboard', payload).then(res => {
            commit('SET_DASHBOARD_DATA', res.data)
            commit('SET_FILTER_STATUS', false)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
};